/*
 DocPreview component
 url match: none
 Shows preview of the first page of the document hovered in the document list
*/
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import { dashboardStyles } from '../../Styles/dashboardStyles';
import Typography from '@material-ui/core/Typography';

@inject('userStore', 'documentStore')
@observer
class DocPreview extends React.Component {

    render() {
        const { classes, showPreview, currentDoc } = this.props;
        return (
          showPreview && currentDoc.imagePreview !== undefined ? <div className={classes.previewContainer}>
              <div className={classes.previewHeader}>
                <Typography variant="subtitle1" style={{color: 'white'}} >
                  {currentDoc.originalFileName}
                </Typography>
                <Typography variant="caption" style={{color: 'white'}} >
                  {currentDoc.totalPages} Pages, {currentDoc.reviewedPageCount} Reviewed
                </Typography>
              </div>
              <div style={{textAlign: 'center'}}>
              <img alt="preview" className={classes.images} src={currentDoc.imagePreview}></img>

              </div>
            </div>: null

        )
    }
}

export default withStyles(dashboardStyles, { withTheme: true })(withRouter(DocPreview));
